
export const getFBDateNow = (): string => (new Date()).toString()

export const fbDateToUnix = (state: string): number => (new Date(state)).getTime()

export const nodeDateToFbDate = (date: Date): string => date.toString()

export const CURRENT_APP_VERSION = 1


export type FBDate = string;

export type InterestRate = number;

export type ContryId = string;

export type FBImageURL = string

export const DefaultPersonalAccountId = "DefaultPersonalAccount"

export const DefaultId = "default";

export const DefaultURL = "https://app.fundbricks.com/";

export const AdminURLDEV = "https://development.d2mj0hu2drdho5.amplifyapp.com/";
export const AdminURLPROD = "https://main.d2mj0hu2drdho5.amplifyapp.com/";

export const ResourceUrl = "https://prod-attachments-bucket-fb-2-0.s3.eu-west-1.amazonaws.com/";

export const FBPersons = ["Team Fundbricks", "Anton Tobias Jensen", "Kaare Korsbek", "Thomas Rolin", "Thomas Sonne-Schmidt", "Thomas Sonne-Schmidt", "Christopher Lund"]

export const FBReferrerOptions = ["reference-facebook", "reference-google", "reference-friend-family", "reference-linkedin", "reference-printed-media", "reference-villa-byerne", "reference-other"]


export enum ContentType {
    Markdown = "Markdown",
    HTML = "HTML"
}